import { Injectable } from '@angular/core';
import { UserRole } from './user-role';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {
  private client: string[];

  setUserRoles(access: string[]) {
    this.client = access;
  }

  getUserRoles() {
    return this.client;
  }

  isShipperRole(): boolean {
    return this.client?.includes(UserRole.Transporteur) ?? false;
  }

}
